// extracted by mini-css-extract-plugin
module.exports = {"option":"styles_option__29y9N"};